import apiClient from './client';
import type { CalendarResponse, CalendarQuery } from '@shared/types/calendar';

export const calendarApi = {
  // GET /api/v1/assistants/{assistantId}/calendar?from=...&to=...&type=...
  getCalendar: async (
    assistantId: string,
    query: CalendarQuery,
  ): Promise<CalendarResponse> => {
    const params = new URLSearchParams({
      from: query.from,
      to: query.to,
    });
    if (query.type && query.type !== 'all') {
      params.set('type', query.type);
    }
    if (query.coach_id) {
      params.set('coach_id', query.coach_id);
    }
    if (query.group_id) {
      params.set('group_id', query.group_id);
    }
    const response = await apiClient.get<CalendarResponse>(
      `/assistants/${assistantId}/calendar?${params.toString()}`,
    );
    return response.data;
  },
};
